import { ObservableFromFetch } from "../ObservableFromFetch"

export function CreateSiteAdministrator(email: string, phone: string, link: string, roleId: number) {
  const requestBody: string = JSON.stringify({
    EmailAddress: email,
    Link: link,
    PhoneNumber: phone,
    RoleID: roleId,
  })

  return ObservableFromFetch<string>("FFOrderClinicEnrollment/CreateSiteAdministrator", requestBody)
}

export interface UserInviteData {
  EmailAddress: string
  Link: string
  ModifiedBy: string
  RoleID: number
  PhoneNumber: string
  InvitationLink?: string
}

export interface UserUploadData {
  Base64String: string
  IPAddress: string
  Link: string
  ModifiedBy: string
  RoleID: number
}

export function UserInvitation(data: UserInviteData) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("FFOrderUserInvitation/UserInvitation", requestBody)
}

export function UserUpload(data: UserUploadData) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("FFOrderUserInvitation/UploadUser", requestBody)
}

export function UserUploadV2(data: UserUploadData) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("FFOrderUserInvitation/UploadUserV2", requestBody)
}

export interface PortalInviteData {
  CompanyName: string
  EmailAddress: string
  Link: string
  ModifiedBy: string
  PhoneNumber: string
  RoleID: number
  IsExistingUser: boolean
  ImplementationID: number
  SubscriptionPlanID: number
  IsGOVTPortal: boolean
  Address1?: string,
  Address2?: string,
  City?: string,
  State?: string,
  Zip?: string,
  OfficePhone?: string,
  SubscriptionPlan?: string,
  ImplementationType?: string,
  FirstName?: string,
  LastName?: string,
  UnmaskDonorID: number
  NoLabAccount: number
  GenerateResultExceptions: boolean
  HideAuthESS: boolean
}

export function PortalInvitation(data: PortalInviteData) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("FFOrderClinicEnrollment/CreateInvitation", requestBody)
}

export interface CompanyInviteData {
  ClientName: string
  CompanyAdditionalRoleID: string
  CompanyCode: string
  CompanyID?: number
  EmailAddress: string
  InvitationLink?: string
  Link: string
  ModifiedBy: string
  PhoneNumber: string
  PortalAdditionalRoleID: string
  RoleID?: number | string
  ParentID?:  number
  IsExistingUser?: boolean
}

export function CompanyInvitationObserver(data: CompanyInviteData) {
  const requestBody: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderClinicEnrollment/CreateInvitation", requestBody)
}

export interface CompanyUploadData {
  Base64String: string
  IPAddress: string
  Link: string
  ModifiedBy: string
}

export function CompanyUpload(params: CompanyUploadData) {
  const requestBody: string = JSON.stringify(params);
  return ObservableFromFetch<string>("FFOrderClinicStatus/UploadClients", requestBody)
}
